module.exports = __webpack_public_path__ + "img/1588095771.9a5c0e3e.jpg";